import SetupBoard from "./SetupBoard";

export default SetupBoard;